module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"LOAN NOTICES"},"et":{"title":"LOAN NOTICES"},"ru":{"title":"LOAN NOTICES"}}')
  delete Component.options._Ctor
}
